// How instants, quantities and durations read, in the viewer's own locale and time zone.

const dateTime = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' });
const date = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium' });
const number = new Intl.NumberFormat(undefined, { maximumFractionDigits: 3 });

export const formatDateTime = (value: string | null | undefined): string =>
    value ? dateTime.format(new Date(value)) : '—';

export const formatDate = (value: string | null | undefined): string => (value ? date.format(new Date(value)) : '—');

export const formatQuantity = (value: number, unit?: string | null): string =>
    unit ? `${number.format(value)} ${unit}` : number.format(value);

/** "2 h 10 min", "45 min", "3 d 4 h": how long since `since`, at `now`. */
export function formatDuration(since: string, now: Date = new Date()): string {
    const minutes = Math.max(0, Math.floor((now.getTime() - new Date(since).getTime()) / 60_000));
    const days = Math.floor(minutes / 1440);
    const hours = Math.floor((minutes % 1440) / 60);
    const rest = minutes % 60;
    if (days > 0) return `${String(days)} d ${String(hours)} h`;
    if (hours > 0) return `${String(hours)} h ${String(rest)} min`;
    return `${String(rest)} min`;
}

/** A person's name as shown. */
export const personOf = (signature: { displayName: string } | null | undefined): string =>
    signature?.displayName ?? '—';

/** An assembly as MIST.Web titles one: "MIST-1000-A — Coolant pump", or the part number alone. */
export const titleOf = (partNumber: string, name: string | null | undefined): string =>
    name ? `${partNumber} — ${name}` : partNumber;
